<template>
  <LayoutMobileHeader></LayoutMobileHeader>
  <LayoutDesktopHeader></LayoutDesktopHeader>
</template>

<script setup>
import * as Sentry from "@sentry/vue";
import { useMainStore } from "~/stores/main";

// -----------------------
// props & emits
// -----------------------
const config = useRuntimeConfig();

// -----------------------
// composables
// -----------------------
const mainStore = useMainStore();

// -----------------------
// plugins
// -----------------------
// const { $api } = useNuxtApp();

// -----------------------
// init logic
// -----------------------
// console.time("fetchMenu"); // Start timing
/*
const { data: menuItems } = await useAsyncData("menuItems_CK", () =>
  $api(`cmspage-menu/${config.public.mainMenuId}`),
);
*/
try {
  mainStore.menuItems = await $fetch(`/api/cmspageMenu`, {
    params: { id: config.public.mainMenuId },
  });
  // console.timeEnd("fetchMenu"); // End timing and print the elapsed time
} catch (error) {
  Sentry.captureEvent({
    message: `Failed to fetch menu items`,
    level: "error",
    extra: {
      key: "ER-ALV3",
      id: config.public.mainMenuId,
      error,
    },
  });
}
</script>
